import { render, staticRenderFns } from "./SourcesSection.vue?vue&type=template&id=e85310ec&scoped=true&"
import script from "./SourcesSection.vue?vue&type=script&lang=js&"
export * from "./SourcesSection.vue?vue&type=script&lang=js&"
import style0 from "./SourcesSection.vue?vue&type=style&index=0&id=e85310ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e85310ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/www/html/insights/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VPagination } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
import { VRadio } from 'vuetify/lib'
import { VRadioGroup } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VAlert,VBtn,VCard,VCheckbox,VDataTable,VDialog,VFlex,VIcon,VLayout,VPagination,VProgressLinear,VRadio,VRadioGroup,VSnackbar,VTextField})
